import { render } from "./withAdminLayout.vue?vue&type=template&id=e44558ec"
import script from "./withAdminLayout.vue?vue&type=script&lang=js"
export * from "./withAdminLayout.vue?vue&type=script&lang=js"

import "./withAdminLayout.vue?vue&type=style&index=0&id=e44558ec&lang=css"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__